import React, { Component } from 'react';
import firebase from '../Firebase';
import { Link } from 'react-router-dom';

class Show extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tutorial: {},
      key: ''
    };
  }

  componentDidMount() {
    const ref = firebase.firestore().collection('tutorials').doc(this.props.match.params.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        this.setState({
          tutorial: doc.data(),
          key: doc.id,
          isLoading: false
        });
      } else {
        console.log("No such document!");
      }
    });
  }

  delete(id){
    firebase.firestore().collection('tutorials').doc(id).delete().then(() => {
      console.log("Document successfully deleted!");
      this.props.history.push("/list")
    }).catch((error) => {
      console.error("Error removing document: ", error);
    });
  }

  render() {
    return (
      <div class="container">
                  <nav class=" navbar navbar-dark bg-primary">
                <span class="navbar-brand mb-0 h1" >Showing Tutorial Session details  for the learner:  {this.state.tutorial.learner}</span>
            </nav> <br/> <br/>
        <div class="panel panel-default">
          <div class="panel-heading">
            <h3 class="panel-title">
              {this.state.tutorial.title}
            </h3>
          </div>
          <div class="panel-body">
            <dl>
              <dt>Tutor:</dt>
              <dd>{this.state.tutorial.tutor}</dd>
              <dt>Learner:</dt>
              <dd>{this.state.tutorial.learner}</dd>
              <dt>Subject:</dt>
              <dd>{this.state.tutorial.subject}</dd> 
              <dt>Content</dt>
              <dd>{this.state.tutorial.content}</dd> 
              <dt>School:</dt>
              <dd>{this.state.tutorial.school}</dd> 
              <dt>Rating</dt>
              <dd>{this.state.tutorial.rating}</dd> 
            </dl>
            <nav class="navbar navbar-dark bg-primary">
             <a  class="navbar-brand" ><Link to={`/edit/${this.state.key}`} class="btn btn-success">Edit</Link></a>
             <a class="navbar-brand"><Link to="/list" class="btn btn-primary">Back to Tutorials</Link></a>
             <a  class="navbar-brand"><Link to="/list" onClick={this.delete.bind(this, this.state.key)} class="btn btn-danger">Delete</Link></a>
            </nav>
          </div>
        </div>
      </div>
    );
  }
}

export default Show;